import { render, staticRenderFns } from "./SocietyModule.vue?vue&type=template&id=1deb53fa&"
import script from "./SocietyModule.vue?vue&type=script&lang=js&"
export * from "./SocietyModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports